import { ApplicationConfig, inject, provideAppInitializer } from '@angular/core';
import { provideRouter, withPreloading } from '@angular/router';

import { routes } from './app.routes';
import { TranslationService } from './services/translation/translation.service';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './services/interceptors/auth.interceptor';
import { errorsInterceptor } from './services/interceptors/errors.interceptor';
import { provideAnimations } from '@angular/platform-browser/animations';
import { BnNgIdleService } from 'bn-ng-idle';
import { SelectivePreloadingStrategy } from './services/navigation/selective-preloading.strategy';


function initializeTranslations(
  translationService: TranslationService,
): Promise<void> {
  return new Promise((resolve, reject) => {
    if (!translationService.isInitialized()) {
      translationService
        .initialise()
        .then(() => resolve())
        .catch(reject);
    } else {
      resolve();
    }
  });
}

export const appConfig: ApplicationConfig = {
  providers: [provideRouter(routes, withPreloading(SelectivePreloadingStrategy)),
    provideAppInitializer(() => {
        const initializerFn = ((translationService: TranslationService) => {
        return () => {
          return initializeTranslations(translationService);
        };
      })(inject(TranslationService));
        return initializerFn();
      }),
    provideHttpClient(
			withInterceptors([authInterceptor, errorsInterceptor]),
		),
    provideAnimations(),
    BnNgIdleService
  ]
  
};
